import * as React from 'react';
import {view, Checkbox} from '@sail/ui';

export const Indeterminate = () => {
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(true);
  return (
    <view.div
      css={{
        layout: 'column',
      }}
    >
      <Checkbox
        label="This Checkbox is aggregating the state of the Checkboxes below it."
        readOnly
        key={checked1 && checked2}
        defaultChecked={checked1 && checked2}
        indeterminate={checked1 !== checked2}
      />
      <Checkbox
        label="Checkbox 1"
        onChange={(e) => {
          setChecked1(e.target.checked);
        }}
      />
      <Checkbox
        label="Checkbox 2"
        defaultChecked
        onChange={(e) => {
          setChecked2(e.target.checked);
        }}
      />
    </view.div>
  );
};
